<template>
    <div class="footer">
        <van-button type="info" block @click="back">{{text}}</van-button>
    </div>
</template>
<script>
    export default {
        props: {
            text: {
                type: String,
                default: '返回上级页面'
            }
        },
        methods: {
            back() {
                this.$emit("back")
            }
        }
    }
</script>
<style lang="scss" scoped>
    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        height: 84px;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 0 30px;
        button {
            border-radius: 8px;
        }
    }
</style>